import React from "react";
import T from "prop-types";
import { get } from "lodash";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import * as actions from "MODULES/RepairOrders/actions";
import {
  form,
  Form as AppForm,
  CurrencyField
} from "MODULES/shared/components/Forms";
import { dollars } from "LIB/formatters/currency";
import * as rules from "LIB/validation/rules";
import { validator } from "LIB/validate-this";
import { Warning } from "MODULES/shared/components";

function Form(props) {
  const { originalPPCost, lineItem } = props;

  const costAdjDeduction = originalPPCost - lineItem.inventory_total_cost;

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <h5 className="h3 text-center">
          This Inventory has a cost of {dollars(lineItem.inventory_total_cost)}
        </h5>
        <Row>
          <Col md={6} mdOffset={3}>
            <Field
              name="original_piece_part_cost"
              component={CurrencyField}
              label="Orig. Shop PP Cost"
            />
          </Col>
        </Row>
        <hr className="hr-xs hr-dashed" />
        <Warning>
          &nbsp;This will deduct a total of {dollars(costAdjDeduction)} from{" "}
          {get(lineItem, "repaired_line_item.part.part_number")} /{" "}
          {get(lineItem, "repaired_line_item.serial_number")} and it will zero
          out the cost on the Shop Assist Inventory. Continue?
        </Warning>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  lineItem: T.shape({
    received: T.bool.required
  })
};

const formName = "costSavingsForm";
const selector = formValueSelector(formName);

export default connect(
  state => ({
    originalPPCost: selector(state, "original_piece_part_cost") || 0
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(
        actions.shopAssistCostSavings(
          ownProps.lineItem.id,
          data,
          ownProps.reload
        )
      )
  })
)(
  form({
    form: formName,
    validate: values =>
      validator(values, f => {
        f.validate("cost_savings").satisfies(rules.required);
        f.validate("cost_savings").satisfies(rules.isNumeric);
        f.validate("cost_savings").satisfies(rules.isGreaterThanOrEqualTo(0));
      })
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/LineItemControls/CoreReturnCostSavings/Form.jsx